<ifr-page-title pageTitle="'LEFT_PANEL_VISITOR_SELFPREREGISTRATION' | translate "/>
<div class="dialogue-fullscreen">
    <vsp-container
      set-language="ctrl.setLanguage"
      activity-right="ctrl.activityRight"
    />
</div>
